(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-video-fixed"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const FIXED_CLASS = 'header-section-fixed';
    const HEADER_OFFSET = -30;

    const init = () => {
      document.body.classList.add('has-fixed-video');

      const headerSections = document.querySelector('.header-sections');

      if (!headerSections || headerSections.dataset.fixedVideoObserverInitialized === 'true') {
        return;
      }

      headerSections.dataset.fixedVideoObserverInitialized = 'true';

      let sentinel = document.querySelector('[data-header-sections-sentinel]');

      if (!sentinel) {
        sentinel = document.createElement('div');
        sentinel.dataset.headerSectionsSentinel = 'true';
        sentinel.setAttribute('aria-hidden', 'true');
        sentinel.style.position = 'absolute';
        sentinel.style.top = `calc(100vh - ${HEADER_OFFSET}px)`;
        sentinel.style.left = '0';
        sentinel.style.width = '1px';
        sentinel.style.height = '1px';
        sentinel.style.pointerEvents = 'none';
        document.body.appendChild(sentinel);
      }

      const updateHeaderState = (isFixed) => {
        headerSections.classList.toggle(FIXED_CLASS, isFixed);
      };

      const observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        updateHeaderState(!entry.isIntersecting && entry.boundingClientRect.top <= 0);
      });

      observer.observe(sentinel);

      window.addEventListener(
        'resize',
        () => {
          updateHeaderState(sentinel.getBoundingClientRect().top <= 0);
        },
        { passive: true }
      );
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
      return;
    }

    init();
  })();

  } catch(e) { console.error(e); }
})();
})();
